import React, { useEffect, useState } from "react";
import { GetEmployeesByIdData, GetRoles } from "../../../lib/data";
import AddEmployeesUi from "../../../ui/employeesUi/addEmployees";
import EditEmployeesUi from "../../../ui/employeesUi/editEmployees";
import { useParams } from "react-router-dom";
import i18n from "../../../lib/i18n";

export default function EditEmployees () {

    const {employeeId} = useParams();
    const [rolesData, setrolesData] = useState([]);
    const [employeesData, setEmployeesData] = useState([]);
    const t = i18n.t.bind(i18n); 
    
    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const rolesData = await GetRoles();
        const employeeData = await GetEmployeesByIdData(employeeId);
        setrolesData([]);
        setEmployeesData({});
        rolesData.map((e) => setrolesData((prev) => [...prev, e]));
        setEmployeesData(employeeData.data);
    };

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("edit_page_title.employee")}</h1>
                <EditEmployeesUi employeesData={employeesData} rolesData={rolesData}/>
            </div>
        </div>
    );
};